import { render } from "./TitheHistoryCard.vue?vue&type=template&id=4700c378&scoped=true"
import script from "./TitheHistoryCard.vue?vue&type=script&lang=js"
export * from "./TitheHistoryCard.vue?vue&type=script&lang=js"

import "./TitheHistoryCard.vue?vue&type=style&index=0&id=4700c378&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4700c378"]])

export default __exports__